import React from "react";
import classNames from "classnames";
import { LABEL_ICON, LABEL_PREVIEW, GOODS_ICON, GOODS_PREVIEW } from "./util";
import styles from "./index.module.scss";

/**
 * 示例
 */
export default function Detail() {
  return (
    <section className={styles.detail}>
      <div className={styles.detailItem}>
        <section className={styles.detailTitleWrapper}>
          <h1 className={styles.title}>
            <img src={LABEL_ICON} alt="label" className={styles.icon} />
            丰富的人群标签
          </h1>
          <div className={styles.detailDescription}>
            提供丰富的人群标签包括「基本特征」、「位置信息」、「用户行为」、「社会特征」、「消费特征」和「手机」六大类标签，全面分析圈选的人群包的用户画像。
          </div>
        </section>
        <img src={LABEL_PREVIEW} alt="preview" className={styles.preview} />
      </div>
      <div className={classNames(styles.detailItem, styles.goodsDetail)}>
        <img src={GOODS_PREVIEW} alt="preview" className={styles.preview} />
        <section className={styles.detailTitleWrapper}>
          <h1 className={styles.title}>
            <img src={GOODS_ICON} alt="label" className={styles.icon} />
            洞察店铺/商品人群
          </h1>
          <div className={styles.detailDescription}>
            支持查看店铺/商品的点击人群，搜索人群，购买人群，分享人群等人群的人群画像，帮助你了解自己的人群资产。
          </div>
        </section>
      </div>
    </section>
  );
}
